import { render, staticRenderFns } from "./consent-collection-layout.vue?vue&type=template&id=6f88711b"
import script from "./consent-collection-layout.vue?vue&type=script&lang=js"
export * from "./consent-collection-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports